var _circle, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FDF2F8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6363 109.19C100.136 108.392 103.62 110.583 104.418 114.083C107.198 126.281 115.167 131.573 124.256 137.041C124.578 137.235 124.905 137.431 125.237 137.63C129.325 140.079 134.061 142.916 137.603 146.598C141.831 150.994 144.484 156.653 143.999 164.217C143.519 171.688 139.565 177.251 134.363 181.127C129.324 184.881 122.947 187.22 116.686 188.718C104.13 191.724 90.0244 191.81 82.2011 191.329C78.618 191.109 75.8921 188.025 76.1126 184.442C76.333 180.859 79.4164 178.133 82.9995 178.354C90.1434 178.793 102.833 178.667 113.66 176.076C119.091 174.776 123.552 172.97 126.595 170.703C129.474 168.557 130.843 166.221 131.025 163.385C131.254 159.822 130.193 157.647 128.233 155.61C125.938 153.223 122.622 151.229 117.944 148.415C117.815 148.337 117.685 148.259 117.554 148.18C108.285 142.603 95.8248 134.885 91.7429 116.972C90.9453 113.472 93.1362 109.988 96.6363 109.19Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8705 194.18L34.5058 198.018C34.5058 198.018 17.5435 179.272 19.018 156.143C20.9207 126.297 33.8784 62.7267 33.8784 62.7267L72.1647 60.0234C72.1647 60.0234 86.1895 106.514 95.1071 147.625C100.724 173.519 88.8705 194.18 88.8705 194.18Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.169 68.9329L70.1509 66.1805C70.1509 66.1805 81.6572 77.8204 82.812 94.1759C83.4549 103.281 81.0851 116.611 78.8577 126.641L72.3199 186.485C75.6696 192.492 75.1703 193.491 73.0577 196.934L63.0296 197.642C60.6058 194.573 59.6564 193.046 63.3477 186.234C63.2432 182.54 63.1459 179.027 63.0528 175.665C62.7364 164.237 62.4683 154.557 62.1319 145.446C60.4513 145.87 58.798 146.179 57.3011 146.284C55.8151 146.389 54.1406 146.318 52.4179 146.139L56.6707 186.743C61.0044 191.666 60.2003 193.933 58.9576 197.437C58.897 197.608 58.8354 197.782 58.7733 197.959L49.9254 198.584C49.705 198.402 49.4942 198.233 49.2935 198.071C46.7465 196.021 45.8403 195.291 47.8487 188.396C46.965 184.808 46.1267 181.395 45.3245 178.129C40.9385 160.273 37.6314 146.809 33.8913 133.049C29.57 122.892 23.6011 107.467 22.961 98.4018C22.2612 88.4894 31.169 68.9329 31.169 68.9329Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3306 30.9232C89.0909 29.5872 68.5921 39.9945 68.5921 39.9945C65.8071 38.5071 62.9456 37.2867 60.2452 36.6578C55.8778 35.6406 50.578 35.8554 45.5404 36.562C45.5404 36.562 29.6702 21.7336 27.4987 22.864C25.3273 23.9943 27.6941 42.5072 27.6941 42.5072L25.829 64.3858C27.3884 76.132 50.0339 87.739 50.0339 87.739C50.0339 87.739 74.2811 85.4985 79.7538 75.6157L84.7414 53.86C84.7414 53.86 93.5702 32.2591 91.3306 30.9232Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1445 63.3115C48.339 66.066 45.9115 63.4691 43.1569 63.6636C40.4023 63.8581 38.3638 66.7704 38.1693 64.0158C37.9748 61.2612 40.1558 60.3668 42.9104 60.1723C45.6649 59.9778 47.95 60.5569 48.1445 63.3115Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0524 69.043C67.9642 71.581 66.995 68.1608 64.457 67.0726C61.919 65.9844 58.7734 67.6402 59.8616 65.1023C60.9498 62.5643 63.2983 62.7677 65.8362 63.8559C68.3742 64.9441 70.1406 66.505 69.0524 69.043Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2181 75.9527C52.5588 76.503 53.3246 76.5895 53.7796 76.1292L57.2075 72.6606C57.7944 72.0668 57.4382 71.0578 56.6086 70.964L50.6135 70.2863C49.7839 70.1926 49.2114 71.0966 49.6509 71.8064L52.2181 75.9527Z",
    fill: "#C5AAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.397 47.9895L64.2669 37.3357L68.6364 39.7335L62.397 47.9895Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4194 46.067L45.2205 36.0986L50.1924 35.7475L49.4194 46.067Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4015 58.7857L62.5257 37.5757C62.5257 37.5757 59.5742 36.2685 57.3972 35.9329C55.2203 35.5972 51.3769 35.8567 51.3769 35.8567L54.4015 58.7857Z",
    fill: "#676767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 95.6675,
    y1: 109.411,
    x2: 78.1995,
    y2: 183.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 54.4631,
    y1: 110.207,
    x2: 60.3262,
    y2: 196.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 50.8569,
    y1: 67.5428,
    x2: 60.0588,
    y2: 197.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 55.5941,
    y1: 33.938,
    x2: 51.0242,
    y2: 89.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder2);
export default __webpack_public_path__ + "static/media/user-placeholder-2.bc4896f93a587f34f924d349ff79ead4.svg";
export { ForwardRef as ReactComponent };